import React, { forwardRef } from 'react'

import SelectSingle from './SelectSingle'
import SelectMultiple from './SelectMultiple'

export const Select = forwardRef(({ isMultiple = false, ...props }, ref) =>
  isMultiple ? <SelectMultiple {...props} ref={ref} /> : <SelectSingle {...props} ref={ref} />
)

export default Select
